export function shouldShowRareFindCue(flow) {
    return Boolean(flow?.isCalculated && flow?.rareFindMetric?.enabled);
}
